import * as Yup from 'yup';

const schemas = {
  nameFn: (field: string, required = true) => (required ? Yup.string().required('Это поле обязательно') : Yup.string())
    .min(2, `${field} не может содержать менее 2-х символов`)
    .max(255, `${field} не может содержать более 255 символов`)
    .test(
      'valid characters',
      `${field} может состоять только из букв латинского и кириллического алфавитов, знаков тире и пробелов`,
      (value) => !value || !!value?.match(/^[a-zA-Zа-яА-ЯёЁ-\s]*$/),
    ),
  date: Yup.string()
    .required('Это поле обязательно')
    .matches(
      /^(0[1-9]|[12][0-9]|3[01])\.(0[1-9]|1[0-2])\.(\d{4})$/,
      'Неверный формат даты. Допустимый формат: дд.мм.гггг',
    ),
  telegram: Yup.string()
    .optional()
    .transform((value) => value.replace(/^@/, ''))
    .matches(/^(?=.{5,32}$)@?[a-zA-Z][a-zA-Z0-9_]*$/, 'Неверно указан никнейм'),
  phone: Yup.string()
    .required('Это поле обязательно')
    .max(18, 'Длина номера телефона не должна быть больше 18 символов')
    .matches(
      /(^8|7|\+7)((\d{10})|(\s\(\d{3}\)\s\d{3}\s\d{2}\s\d{2}))/,
      'Неверно указан номер телефона',
    ),
  email: Yup.string()
    .test(
      'one character in domain of first level',
      'Неверный домен первого уровня',
      (value) => !value?.match(/\..$/),
    )
    .test(
      'wrong defis',
      'Знак "-" расположен неверно',
      (value) => !value?.match(/(^-|-$|-@|@-|-\.|\.-)/),
    )
    .test(
      'no cyrillic',
      'Email не должен содержать русских букв',
      (value) => !value?.match(/[а-яА-ЯёЁ]/),
    )
    .email('Неверно указан Email')
    .max(255, 'Максимальное количество символов - 255')
    .required('Это поле обязательно'),
  cvFile: Yup.mixed()
    .test('required', 'Это поле обязательно', (value: File | null) => !!value)
    .test(
      'fileSize',
      'Файл слишком большой',
      (value: File | null) => !!value && value.size < 2.4e7,
    )
    .test(
      'extensions',
      'Недопустимое расширение файла, допустимые расширения: .pdf, .doc, .docx',
      (value: File | null) => !!value && !!value.name.match(/(.pdf$|.doc$|.docx$)/),
    ),
};

export const ResponseSchema = Yup.object().shape({
  lastName: schemas.nameFn('Фамилия'),
  firstName: schemas.nameFn('Имя'),
  patronymic: schemas.nameFn('Отчество', false),
  birthdate: schemas.date,
  phoneNumber: schemas.phone,
  telegram: schemas.telegram,
  email: schemas.email,
  currentWorkplace: Yup.string().required('Это поле обязательно'),
  currentJob: Yup.string().required('Это поле обязательно'),
  expectedSalary: Yup.string(),
  coverLetter: Yup.string(),
  cvFile: schemas.cvFile,
  checkPersonalData: Yup.bool().oneOf([true], 'Это поле обязательно'),
  checkIT: Yup.bool(),
});

export const RecommendSchema = Yup.object().shape({
  recommenderLastName: schemas.nameFn('Фамилия'),
  recommenderFirstName: schemas.nameFn('Имя'),
  recommenderPatronymic: schemas.nameFn('Отчество', false),
  recommenderPhoneNumber: schemas.phone,
  recommenderEmail: schemas.email,
  checkPersonalData: Yup.bool().oneOf([true], 'Это поле обязательно'),
  recommendedLastName: schemas.nameFn('Фамилия'),
  recommendedFirstName: schemas.nameFn('Имя'),
  recommendedPatronymic: schemas.nameFn('Отчество', false),
  cvFile: schemas.cvFile,
  recommendedPhoneNumber: schemas.phone,
  recommendedEmail: schemas.email,
  concentToBeRecommended: Yup.bool().oneOf([true], 'Это поле обязательно'),
});
